import { forwardRef } from 'react';
import { Grid, GridProps } from '@mui/material';

/**
 * Standard grid container with default spacing values
 */
export const FormGridContainer = forwardRef<HTMLDivElement, GridProps>((props: GridProps, ref) => {
  return <Grid ref={ref} container columnSpacing={4} rowSpacing={1} {...props} />;
});
